// /components/DietAssessment/components/AssessmentStep.js

import React, { useContext } from 'react';
import { Button, Box, useMediaQuery, useTheme } from '@mui/material';
import { AssessmentContext } from '../../../lib/contexts';

export const AssessmentBackButton = (props) => {
  const theme = useTheme();
  const {
    actions: { handlePreviousStep },
  } = useContext(AssessmentContext);

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleBackOnClick = props?.onClick || handlePreviousStep;
  const { boxSx } = props || {};

  // Use overrideLabel if provided, otherwise fall back to currentStepInfo
  const buttonLabel = props?.overrideLabel || props?.currentStepInfo?.buttonText || 'Back';

  return (
    <Box
      id="assessment-back-button"
      sx={{
        ...theme.globalClasses.assessmentButton,
        maxWidth: '140px',
        backgroundColor: isMobile ? 'background.paper' : 'transparent',
        ...boxSx,
      }}
    >
      <Button
        size="large"
        variant="outlined"
        onClick={handleBackOnClick}
        sx={{
          mb: 2,
          width: '100%',
          maxWidth: '140px',
        }}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};
